export const HERO_TITLE = 'Contact The Bash';
export const HERO_SUBTITLE = 'Have a question or comment? Let us know!';

export const SUBJECTS = {
  APP_FEEDBACK: {
    id: 102,
    name: 'App Feedback',
  },
  AUDIO_PHOTO_VIDEO_QUESTION: {
    id: 46,
    name: 'Audio/Photo/Video Question',
  },
  BILLING_QUESTION: {
    id: 47,
    name: 'Billing Question',
  },
  BOOKING_QUESTION: {
    id: 21,
    name: 'Booking Question',
  },
  DEPOSIT_QUESTION: {
    id: 48,
    name: 'Deposit Question',
  },
  EVENT_CANCELLATION: {
    id: 22,
    name: 'Event Cancellation',
  },
  GENERAL_COMMENT: {
    id: 3,
    name: 'General Comment',
  },
  GENERAL_INQUIRY: {
    id: 50,
    name: 'General Inquiry',
  },
  GIG_REQUEST_QUESTION: {
    id: 15,
    name: 'Gig Request Question',
  },
  INTERESTED_IN_BEING_LIST_ON_THE_BASH: {
    id: 51,
    name: 'Interested in being listed on The Bash',
  },
  MEMBERSHIP_STATUS: {
    id: 19,
    name: 'Membership Status',
  },
  PARTNER_INQUIRY: {
    id: 54,
    name: 'Partner Inquiry',
  },
  PRESS_INQUIRY: {
    id: 32,
    name: 'Press Inquiry',
  },

  PROFILE_QUESTION: {
    id: 7,
    name: 'Profile Question',
  },

  RENEWAL_QUESTION: {
    id: 55,
    name: 'Renewal Question',
  },
  SITE_FUNCTIONALITY_OR_ERROR_MESSAGE: {
    id: 56,
    name: 'Site Functionality/Error Message',
  },
  LOOKING_FOR_EVENT_ENTERTAINMENT: {
    id: 52,
    name: 'Looking for Event Entertainment',
  },
  LOOKING_FOR_PARTY_VENDOR: {
    id: 53,
    name: 'Looking for Party Vendor',
  },
};

export const SUBJECTS_BY_ID = Object.keys(SUBJECTS).reduce((subjectsById, subjectKey) => {
  const subject = SUBJECTS[subjectKey];
  return {
    ...subjectsById,
    [subject.id]: subject,
  };
}, {});

const GENERAL_SUBJECTS = [SUBJECTS.SITE_FUNCTIONALITY_OR_ERROR_MESSAGE, SUBJECTS.GENERAL_COMMENT];

const ENTERTAINER_OR_PARTY_VENDOR_SUBJECTS = [
  SUBJECTS.INTERESTED_IN_BEING_LIST_ON_THE_BASH,
  SUBJECTS.APP_FEEDBACK,
  SUBJECTS.AUDIO_PHOTO_VIDEO_QUESTION,
  SUBJECTS.BILLING_QUESTION,
  SUBJECTS.BOOKING_QUESTION,
  SUBJECTS.DEPOSIT_QUESTION,
  SUBJECTS.EVENT_CANCELLATION,
  SUBJECTS.GIG_REQUEST_QUESTION,
  SUBJECTS.MEMBERSHIP_STATUS,
  SUBJECTS.PROFILE_QUESTION,
  SUBJECTS.RENEWAL_QUESTION,
  ...GENERAL_SUBJECTS,
];

export const FORM_DETAILS_BY_CONTACT_TYPE = {
  'Party Host': {
    enableGigIdField: true,
    enableMemberIdField: false,
    subjects: [
      SUBJECTS.LOOKING_FOR_EVENT_ENTERTAINMENT,
      SUBJECTS.LOOKING_FOR_PARTY_VENDOR,
      SUBJECTS.BILLING_QUESTION,
      SUBJECTS.BOOKING_QUESTION,
      SUBJECTS.EVENT_CANCELLATION,
      ...GENERAL_SUBJECTS,
    ],
  },
  Entertainer: {
    enableGigIdField: true,
    enableMemberIdField: true,
    subjects: ENTERTAINER_OR_PARTY_VENDOR_SUBJECTS,
  },
  'Party Vendor': {
    enableGigIdField: true,
    enableMemberIdField: true,
    subjects: ENTERTAINER_OR_PARTY_VENDOR_SUBJECTS,
  },
  Venue: {
    enableGigIdField: false,
    enableMemberIdField: false,
    subjects: [
      SUBJECTS.INTERESTED_IN_BEING_LIST_ON_THE_BASH,
      SUBJECTS.AUDIO_PHOTO_VIDEO_QUESTION,
      SUBJECTS.BILLING_QUESTION,
      SUBJECTS.EVENT_CANCELLATION,
      SUBJECTS.GIG_REQUEST_QUESTION,
      SUBJECTS.MEMBERSHIP_STATUS,
      SUBJECTS.PROFILE_QUESTION,
      SUBJECTS.RENEWAL_QUESTION,
      ...GENERAL_SUBJECTS,
    ],
  },
  Other: {
    enableGigIdField: false,
    enableMemberIdField: false,
    subjects: [
      SUBJECTS.PRESS_INQUIRY,
      SUBJECTS.GENERAL_INQUIRY,
      SUBJECTS.PARTNER_INQUIRY,
      ...GENERAL_SUBJECTS,
    ],
  },
};

export const WHO_AM_I_OPTIONS = Object.keys(FORM_DETAILS_BY_CONTACT_TYPE);
export const BLOG_PAGE_LINK = 'https://itg.thebash.com/';

export const TRACK_NAME_VALIDATION = 'Contact Us Validation';
export const TRACK_NAME_CTA = 'Contact Us';
export const TRACK_NAME_SUBMIT = 'Contact Us Submit';
export const TRACK_NAME_CLICK_AREA = 'Contact Us';
